// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
// @ components
const { AccountDebitsChangeAccountView } = require('components/contactCenter/accountDebitChange/accountDebitsChangeAccountView/accountDebitsChangeAccountView');
// @ actions
const accountDebitsActions = require('actions/accountDebits');
const changeReceiptAccount = require('actions/contactCenter/changeReceiptAccount/changeReceiptAccount');
// @ constants

class AccountDebitsChangeAccountContainer extends React.Component {

    render() {
        return <AccountDebitsChangeAccountView {...this.props} />
    }
}

AccountDebitsChangeAccountContainer.propTypes = {
    immAccountDebits: PropTypes.object,
    immAccounts: PropTypes.object,
    immProfile: PropTypes.object,
    requestAccountDebits: PropTypes.func,
    match: PropTypes.object,
    changeReceiptAccountConf: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    setDestinationAccountId: PropTypes.func.isRequired,
    setCurrentAccountId: PropTypes.func.isRequired,
    setReceiptNumber: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    immChangeReceiptAccount: PropTypes.object,
    showCancelModal: PropTypes.func.isRequired,
};

module.exports.AccountDebitsChangeAccountContainer = connect(
    state => ({
        immProfile: state.profile,
        immAccountDebits:state.accountDebits,
        immAccounts: state.accounts,
        immChangeReceiptAccount: state.changeReceiptAccount,
    }), ({
        requestAccountDebits: accountDebitsActions.requestAccountDebits,
        changeReceiptAccountConf: changeReceiptAccount.changeReceiptAccountConf,
        validateStep: changeReceiptAccount.validateStep,
        setVisibleStep: changeReceiptAccount.setVisibleStep,
        setWillCancel: changeReceiptAccount.setWillCancel,
        handleFinish: changeReceiptAccount.finish,
        setCurrentAccountId: changeReceiptAccount.setCurrentAccountId,
        reset: changeReceiptAccount.reset,
        setDestinationAccountId: changeReceiptAccount.setDestinationAccountId,
        setReceiptNumber: changeReceiptAccount.setReceiptNumber,
        showCancelModal: changeReceiptAccount.showCancelModal,
    })
)(AccountDebitsChangeAccountContainer);
